// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/prelogin/plant.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/prelogin/window.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .prelogin_layout::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: radial-gradient(
    104% 47.97% at 50% 52.03%,
    #082b23 0%,
    #10182f 100%
  );
  opacity: 0.95;
  pointer-events: none;
  height: auto;
  min-height: 616px;
} */

.prelogin_layout {
  /* max-width: 100%; */
  /* max-height: 100vh; */
  /* height: 468px; */
  /* display: block; */
  /* background-image: url("../../assets/prelogin/login_signup_bg.png"); */
  max-height: 920px;
  background: radial-gradient(104% 47.97% at 50% 52.03%, #082b23 0%, #10182f 100%);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.prelogin_layout>div {
  min-height: 920px;
}

.registerFormWrap .prelogin_heading_first span {
  display: inline-flex;
}

.registerFormWrap .prelogin_heading_first span:nth-child(1) {
  width: 40px;
  align-items: center;
}

.registerFormWrap .prelogin_heading_first span:nth-child(2) {
  width: calc(100% - 50px);
  justify-content: center;
}

.registerContentBox p,
.registerContentBox ul li {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: Lexend;
}

.prelogin_footer {
  background-color: #1B9075;
  height: 2.5rem;
}

.prelogin_footer .prelogin_footer_text {
  font-family: Lexend;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin: auto 0;
}

.registerInner {
  max-width: 630px;
  width: 100%;
  margin: 0 auto 0 0;
  position: relative;
  min-height: 870px;
}

.registerContentBox ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0;
  margin: 0;
}

.registerContentBox ul li {
  display: inline-block;
  width: 50%;
  vertical-align: top;
  line-height: 38px;
  text-align: left;
  position: relative;
}

.registerContentBox ul li:nth-child(odd) {
  padding-left: 10px;
}

.registerContentBox ul li:nth-child(even) {
  padding-left: 17%;
}

.registerContentBox ul li:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 5px;
  border-radius: 100%;
  background: #ffffff;
  top: 50%;
  transform: translateY(-50%);
}

.registerContentBox ul li:nth-child(odd):before {
  left: 0px;
}

.registerContentBox ul li:nth-child(even):before {
  left: 30%;
}

.registerGrapic {
  position: absolute;
  bottom: 0;
  left: 0;
}
.registerGrapic:after {
  position: absolute;
  content: "";
  right: -220px;
  bottom: 50px;
  height: 180px;
  width: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.registration_form_box.signUpBox input {
  height: 44px;
}

.registration_form_box label {
  font-family: Lexend;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  color: #1B9075;
  margin-bottom: 8px;
  display: block;
}

.signupDeclaration p {
  font-family: Lexend;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  text-align: center;
}

.otherSignupMethod>span {
  font-family: Manrope;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  display: block;
  position: relative;
  margin-bottom: 12px;
}

.otherSignupMethod>span:after,
.otherSignupMethod>span:before {
  position: absolute;
  content: "";
  height: 1px;
  width: 46px;
  background: #ECEDED;
  top: 50%;
  transform: translateY(-50%);
}

.otherSignupMethod>span:before {
  left: 0;
}

.otherSignupMethod>span:after {
  right: 0;
}

.registration_form_box:before {
  position: absolute;
  content: "";
  left: -150px;
  height: 180px;
  width: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  top: 35px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* .registration_form_box:after {
  bottom: 50px;
  background-image: url("../../assets/prelogin/plant.png");
} */

/* .login_heading {
  width: 33%;
} */

.login_heading .prelogin_heading_first {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.78px;
  text-align: left;
  color: #fff;

  .prelogin_heading_second {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 700;
    line-height: 32.78px;
    text-align: left;
    color: #1b9075;
  }
}

.login_heading .prelogin_subtext {
  font-family: Lexend;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  text-align: left;
  color: #f6f6f6;
}

.prelogin_otp .opt_field input {
  border: 1px solid #c9c8cf;
  background: #f3f3f3;
}

.prelogin_otp .opt_field .otp_shadow {
  box-shadow: 0px 2px 22px 0px #00000040;
}

.login_box_width {
  width: 33%;
  border-radius: 4px;
  border: 1px solid #263238;
}

/* .registration_form_box {
  width: 33%;
  border-radius: 4px;
  border: 1px solid #263238;
} */
.login_heading {
  max-width: 415px;
  width: 100%;
  margin: 0 0 16px auto;
}

.registration_form_box {
  max-width: 415px;
  width: 100%;
  margin: 0 0 0 auto;
  min-height: 632px;
  border: 1px solid #263238;
  position: relative;
}

.prelogin_box {
  width: 33%;
  border-radius: 4px;
  border: 1px solid #263238;
}

.prelogin_otp {
  width: 33%;
  border-radius: 4px;
  border: 1px solid #263238;
}

/*otp screen css add-on*/
.signUpWrapper{
  display:none;
}
.formDescription p {
  font-size: 16px;
  color: #F6F6F6;
  text-align: center;
  margin-top: 10px;
  padding: 0 5px;
}

.registration_form_box.otpBox input {
  width: 40px;
  height: 53px;
}
.otherMethodBox button {
  width: 158px;
  height: 56px;
}
.haveAcountBox {
  position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
}
.passwordChangeBox .formDescription p {
  color: #263238;
}



@media (max-width: 499px) {
  .login_heading {
    width: 90%;
  }

  .login_box_width {
    width: 90%;
  }

  .registration_form_box {
    width: 90%;
  }

  .prelogin_box {
    width: 90%;
  }

  .prelogin_otp {
    width: 90%;
  }
}

@media (min-width: 500px) and (max-width: 640px) {
  .login_heading {
    width: 80%;
  }

  .login_box_width {
    width: 80%;
  }

  .registration_form_box {
    width: 80%;
  }

  .prelogin_box {
    width: 80%;
  }

  .prelogin_otp {
    width: 80%;
  }
}

@media (min-width: 641px) and (max-width: 1024px) {
  /* .login_heading {
    width: 60%;
  } */

  .login_box_width {
    width: 60%;
  }

  /* .registration_form_box {
    width: 60%;
  } */

  .prelogin_box {
    width: 60%;
  }

  .prelogin_otp {
    width: 60%;
  }
}

@media (min-width: 1025px) and (max-width: 1368px) {}

@media (min-width: 1441px) {
  .registerOuter {
    grid-template-columns: 7fr 5fr;
  }
}

@media (max-width: 1440px) and (min-width: 1280px) {
  .registerContentBox ul li:nth-child(even) {
    padding-left: 12%;
  }

  .registerContentBox ul li:nth-child(even):before {
    left: 20%;
  }
}

@media (max-width: 1280px) {
  .registerContentBox ul li:nth-child(even):before {
    left: -10px;
  }

  .registerContentBox ul li:nth-child(even) {
    padding-left: 0;
  }
.registration_form_box:before, .registerGrapic:after {
    display: none;
  }
}

@media (max-width: 1024px) {
  .registerContentBox ul li {
    width: 100%;
  }

  .registerContentBox ul li:nth-child(even) {
    padding-left: 10px;
  }

  .registerContentBox ul li:nth-child(even):before {
    left: 0px;
  }
  .registerContentBox ul {
    padding-left: 75px;
}

}

@media (max-width: 768px) {
.registerInner {
  /* order: 2; */
  max-width: 100%;
}
.prelogin_layout {
  max-height: 100%;
}
.registration_form_box {
  margin:0 auto 50px auto;
}
.login_heading {
  margin: 0 auto 16px auto;
}
.registerGrapic {
  position: relative;
}
.registration_form_box {
  min-height: auto;
}

}

@media (max-width: 420px) {
.formGrid {
    display: flex;
    flex-flow: column;
    gap: 15px;
}
.justify-around {
  justify-content: space-between;
  gap: 10px;
}
.otherMethodBox button {
  width: 100%;
}
.otherMethodBox span {
  display: block;
  width: 50%;
}
.registration_form_box.otpBox input {
  width: 30px;
}
.registration_form_box.passwordChangeBox .formDescription.px-20 {
  padding-left: 0rem;
  padding-right: 0rem;
}

}`, "",{"version":3,"sources":["webpack://./src/styles/prelogin/prelogin.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,wEAAwE;EACxE,iBAAiB;EACjB,gFAAgF;EAChF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,yDAAwD;AAC1D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAI3B,SAAS;EACT,yDAAyD;AAJ3D;;AAOA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;;EAEX;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;GAIG;AACH;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;IAChB,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;AACA;EACE,cAAc;AAChB;;;;AAIA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,UAAU;EACZ;;EAEA;;KAEG;;EAEH;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,oDAAoD;;AAEpD;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;IACI,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;AACtB;;AAEA;;AAEA;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;AAEA;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;AACb;AACA;EACE,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA","sourcesContent":["/* .prelogin_layout::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: radial-gradient(\n    104% 47.97% at 50% 52.03%,\n    #082b23 0%,\n    #10182f 100%\n  );\n  opacity: 0.95;\n  pointer-events: none;\n  height: auto;\n  min-height: 616px;\n} */\n\n.prelogin_layout {\n  /* max-width: 100%; */\n  /* max-height: 100vh; */\n  /* height: 468px; */\n  /* display: block; */\n  /* background-image: url(\"../../assets/prelogin/login_signup_bg.png\"); */\n  max-height: 920px;\n  background: radial-gradient(104% 47.97% at 50% 52.03%, #082b23 0%, #10182f 100%);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.prelogin_layout>div {\n  min-height: 920px;\n}\n\n.registerFormWrap .prelogin_heading_first span {\n  display: inline-flex;\n}\n\n.registerFormWrap .prelogin_heading_first span:nth-child(1) {\n  width: 40px;\n  align-items: center;\n}\n\n.registerFormWrap .prelogin_heading_first span:nth-child(2) {\n  width: calc(100% - 50px);\n  justify-content: center;\n}\n\n.registerContentBox p,\n.registerContentBox ul li {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  font-family: Lexend;\n}\n\n.prelogin_footer {\n  background-color: #1B9075;\n  height: 2.5rem;\n}\n\n.prelogin_footer .prelogin_footer_text {\n  font-family: Lexend;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 22px;\n  text-align: center;\n  color: #ffffff;\n  margin: auto 0;\n}\n\n.registerInner {\n  max-width: 630px;\n  width: 100%;\n  margin: 0 auto 0 0;\n  position: relative;\n  min-height: 870px;\n}\n\n.registerContentBox ul {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0;\n  margin: 0;\n}\n\n.registerContentBox ul li {\n  display: inline-block;\n  width: 50%;\n  vertical-align: top;\n  line-height: 38px;\n  text-align: left;\n  position: relative;\n}\n\n.registerContentBox ul li:nth-child(odd) {\n  padding-left: 10px;\n}\n\n.registerContentBox ul li:nth-child(even) {\n  padding-left: 17%;\n}\n\n.registerContentBox ul li:before {\n  position: absolute;\n  content: \"\";\n  height: 5px;\n  width: 5px;\n  border-radius: 100%;\n  background: #ffffff;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.registerContentBox ul li:nth-child(odd):before {\n  left: 0px;\n}\n\n.registerContentBox ul li:nth-child(even):before {\n  left: 30%;\n}\n\n.registerGrapic {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.registerGrapic:after {\n  position: absolute;\n  content: \"\";\n  right: -220px;\n  bottom: 50px;\n  height: 180px;\n  width: 100px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(\"../../assets/prelogin/plant.png\");\n}\n\n.registration_form_box.signUpBox input {\n  height: 44px;\n}\n\n.registration_form_box label {\n  font-family: Lexend;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 20px;\n  color: #1B9075;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.signupDeclaration p {\n  font-family: Lexend;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 22px;\n  text-align: center;\n}\n\n.otherSignupMethod>span {\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22px;\n  text-align: center;\n  display: block;\n  position: relative;\n  margin-bottom: 12px;\n}\n\n.otherSignupMethod>span:after,\n.otherSignupMethod>span:before {\n  position: absolute;\n  content: \"\";\n  height: 1px;\n  width: 46px;\n  background: #ECEDED;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.otherSignupMethod>span:before {\n  left: 0;\n}\n\n.otherSignupMethod>span:after {\n  right: 0;\n}\n\n.registration_form_box:before {\n  position: absolute;\n  content: \"\";\n  left: -150px;\n  height: 180px;\n  width: 100px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.registration_form_box:before {\n  top: 35px;\n  background-image: url(\"../../assets/prelogin/window.png\");\n}\n\n/* .registration_form_box:after {\n  bottom: 50px;\n  background-image: url(\"../../assets/prelogin/plant.png\");\n} */\n\n/* .login_heading {\n  width: 33%;\n} */\n\n.login_heading .prelogin_heading_first {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32.78px;\n  text-align: left;\n  color: #fff;\n\n  .prelogin_heading_second {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32.78px;\n    text-align: left;\n    color: #1b9075;\n  }\n}\n\n.login_heading .prelogin_subtext {\n  font-family: Lexend;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 22px;\n  text-align: left;\n  color: #f6f6f6;\n}\n\n.prelogin_otp .opt_field input {\n  border: 1px solid #c9c8cf;\n  background: #f3f3f3;\n}\n\n.prelogin_otp .opt_field .otp_shadow {\n  box-shadow: 0px 2px 22px 0px #00000040;\n}\n\n.login_box_width {\n  width: 33%;\n  border-radius: 4px;\n  border: 1px solid #263238;\n}\n\n/* .registration_form_box {\n  width: 33%;\n  border-radius: 4px;\n  border: 1px solid #263238;\n} */\n.login_heading {\n  max-width: 415px;\n  width: 100%;\n  margin: 0 0 16px auto;\n}\n\n.registration_form_box {\n  max-width: 415px;\n  width: 100%;\n  margin: 0 0 0 auto;\n  min-height: 632px;\n  border: 1px solid #263238;\n  position: relative;\n}\n\n.prelogin_box {\n  width: 33%;\n  border-radius: 4px;\n  border: 1px solid #263238;\n}\n\n.prelogin_otp {\n  width: 33%;\n  border-radius: 4px;\n  border: 1px solid #263238;\n}\n\n/*otp screen css add-on*/\n.signUpWrapper{\n  display:none;\n}\n.formDescription p {\n  font-size: 16px;\n  color: #F6F6F6;\n  text-align: center;\n  margin-top: 10px;\n  padding: 0 5px;\n}\n\n.registration_form_box.otpBox input {\n  width: 40px;\n  height: 53px;\n}\n.otherMethodBox button {\n  width: 158px;\n  height: 56px;\n}\n.haveAcountBox {\n  position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 20px;\n}\n.passwordChangeBox .formDescription p {\n  color: #263238;\n}\n\n\n\n@media (max-width: 499px) {\n  .login_heading {\n    width: 90%;\n  }\n\n  .login_box_width {\n    width: 90%;\n  }\n\n  .registration_form_box {\n    width: 90%;\n  }\n\n  .prelogin_box {\n    width: 90%;\n  }\n\n  .prelogin_otp {\n    width: 90%;\n  }\n}\n\n@media (min-width: 500px) and (max-width: 640px) {\n  .login_heading {\n    width: 80%;\n  }\n\n  .login_box_width {\n    width: 80%;\n  }\n\n  .registration_form_box {\n    width: 80%;\n  }\n\n  .prelogin_box {\n    width: 80%;\n  }\n\n  .prelogin_otp {\n    width: 80%;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1024px) {\n  /* .login_heading {\n    width: 60%;\n  } */\n\n  .login_box_width {\n    width: 60%;\n  }\n\n  /* .registration_form_box {\n    width: 60%;\n  } */\n\n  .prelogin_box {\n    width: 60%;\n  }\n\n  .prelogin_otp {\n    width: 60%;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1368px) {}\n\n@media (min-width: 1441px) {\n  .registerOuter {\n    grid-template-columns: 7fr 5fr;\n  }\n}\n\n@media (max-width: 1440px) and (min-width: 1280px) {\n  .registerContentBox ul li:nth-child(even) {\n    padding-left: 12%;\n  }\n\n  .registerContentBox ul li:nth-child(even):before {\n    left: 20%;\n  }\n}\n\n@media (max-width: 1280px) {\n  .registerContentBox ul li:nth-child(even):before {\n    left: -10px;\n  }\n\n  .registerContentBox ul li:nth-child(even) {\n    padding-left: 0;\n  }\n.registration_form_box:before, .registerGrapic:after {\n    display: none;\n  }\n}\n\n@media (max-width: 1024px) {\n  .registerContentBox ul li {\n    width: 100%;\n  }\n\n  .registerContentBox ul li:nth-child(even) {\n    padding-left: 10px;\n  }\n\n  .registerContentBox ul li:nth-child(even):before {\n    left: 0px;\n  }\n  .registerContentBox ul {\n    padding-left: 75px;\n}\n\n}\n\n@media (max-width: 768px) {\n.registerInner {\n  /* order: 2; */\n  max-width: 100%;\n}\n.prelogin_layout {\n  max-height: 100%;\n}\n.registration_form_box {\n  margin:0 auto 50px auto;\n}\n.login_heading {\n  margin: 0 auto 16px auto;\n}\n.registerGrapic {\n  position: relative;\n}\n.registration_form_box {\n  min-height: auto;\n}\n\n}\n\n@media (max-width: 420px) {\n.formGrid {\n    display: flex;\n    flex-flow: column;\n    gap: 15px;\n}\n.justify-around {\n  justify-content: space-between;\n  gap: 10px;\n}\n.otherMethodBox button {\n  width: 100%;\n}\n.otherMethodBox span {\n  display: block;\n  width: 50%;\n}\n.registration_form_box.otpBox input {\n  width: 30px;\n}\n.registration_form_box.passwordChangeBox .formDescription.px-20 {\n  padding-left: 0rem;\n  padding-right: 0rem;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
